import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin":"30px 0px"} }
const _hoisted_2 = {
  class: "right_cont",
  style: {"width":"100%"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "pagination",
  style: {"padding-bottom":"20px"}
}

import {getNewsContentList} from "@/config/request";
import {reactive, ref, toRefs} from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'messageTable',
  props: {
  keyWord:String,
},
  setup(__props) {

const router = useRouter()
const route = useRoute()
const newsList = ref([]) as any
const pagination = reactive({
  pageNo: 1,
  pageSize: 10,
  pageSizes: [5,10,20],
  total: 0,
})
const props = __props
const { keyWord } = toRefs(props) as any
const getNewsList = async() => {
  let param = {
    title:  keyWord.value?'*'+keyWord.value+'*':keyWord.value,
    pageNo: pagination.pageNo,
    pageSize: pagination.pageSize
  }
  console.log('param',param);

  const res = await getNewsContentList(param) as any
  newsList.value = res.result.records
  pagination.total = res.result?.total || 0
}

const showDetail = (item:any) => {
  router.push({
    path: '/news-detail',
    query:{
      id: item.id
    }
  })
}
const handleCurrentChange = (index:any) => {
  pagination.pageNo = index
  getNewsList()
}
const handleSizeChange = (index:any) => {
  pagination.pageSize = index
  getNewsList()
}
getNewsList()

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"24px","font-weight":"700","position":"relative","top":"-10px"} }, " 新闻类 ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "t6_title_h1" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        data: newsList.value,
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "标题",
            width: "600"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("a", {
                type: "primary",
                onClick: ($event: any) => (showDetail(scope.row))
              }, _toDisplayString(scope.row.title), 9, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "releaseDate",
            label: "发布时间",
            width: "300",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "200",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (showDetail(scope.row))
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("查看", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_pagination, {
          background: "",
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleSizeChange,
          layout: "total, prev, pager, next, jumper",
          "page-size": pagination.pageSize,
          "page-sizes": pagination.pageSizes,
          total: pagination.total
        }, null, 8, ["page-size", "page-sizes", "total"])
      ])
    ])
  ]))
}
}

})